import {Component, Inject, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {VehiclesService} from '../../../../../../data/vehicles/vehicles.service';
import {VehicleCategoryModel} from '../../../../../../shared/models/vehicle';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatCheckbox} from '@angular/material/checkbox';
import {ObservationGroupTypeDto} from '../../../../../../shared/models/observation-group';
import {ObservationManagementService} from '../../../../../../data/observations/observation-management.service';
import {MatProgressBar} from '@angular/material/progress-bar';

@Component({
  selector: 'app-assign-observation-group-to-vehicle-groups-dialog',
  imports: [
    FormsModule,
    MatDialogContent,
    MatDialogTitle,
    ReactiveFormsModule,
    MatDialogActions,
    MatDialogClose,
    MatButton,
    MatProgressSpinner,
    MatCheckbox,
    MatProgressBar,
  ],
  templateUrl: './assign-observation-group-to-vehicle-groups-dialog.component.html',
  styleUrls: ['../../../../settings-common.scss']
})
export class AssignObservationGroupToVehicleGroupsDialogComponent implements OnInit {
  isLoading = false;
  vehicleGroups: VehicleCategoryModel[] = [];

  selectedVehicleCategoryIds = {};

  isSaving = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public group: ObservationGroupTypeDto,
    private readonly matDialog: MatDialogRef<any>,
    private readonly observationManagementService: ObservationManagementService,
    private readonly vehiclesService: VehiclesService,
  ) {
    this.isLoading = true;

    this.selectedVehicleCategoryIds = (group.vehicleGroups || []).reduce((p, c) => {
      p[c.id] = true;
      return p;
    }, {});
  }

  ngOnInit() {
    this.vehiclesService.getVehicleCategories()
      .then(result => {
        this.vehicleGroups = result;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  assignGroups() {
    this.isSaving = true;

    const vehicleGroupIds = Object.keys(this.selectedVehicleCategoryIds)
      .filter(id => this.selectedVehicleCategoryIds[id])
      .map(it => Number(it));

    const vehicleGroupToUpdate = {
      ...this.group,
      vehicleGroupIds
    };
    delete vehicleGroupToUpdate.vehicleGroups;

    this.observationManagementService.updateObservationTypeGroup(this.group.id, vehicleGroupToUpdate)
      .then(() => {
        this.matDialog.close(true);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
}
